import { switchMap } from './switchMap';
import { Observable } from '../Observable';
import { createOperatorSubscriber } from './OperatorSubscriber';
export function switchScan(accumulator, seed) {
    return function (source) {
        return new Observable(function (subscriber) {
            var state = seed;
            switchMap(function (value, index) { return accumulator(state, value, index); })(source).subscribe(createOperatorSubscriber(subscriber, function (innerValue) {
                state = innerValue;
                subscriber.next(innerValue);
            }));
            return function () {
                state = null;
            };
        });
    };
}
//# sourceMappingURL=switchScan.js.map